module.exports = __webpack_public_path__ + "static/media/homeimg.dc3f71b1.png";